var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 184,
    viewBox: "0 0 184 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92 184C73.8041 184 56.0169 178.604 40.8876 168.495C25.7583 158.386 13.9664 144.018 7.00312 127.207C0.0398625 110.396 -1.78204 91.898 1.7678 74.0517C5.31763 56.2055 14.0798 39.8126 26.9462 26.9462C39.8126 14.0798 56.2055 5.31763 74.0517 1.7678C91.898 -1.78204 110.396 0.0398625 127.207 7.00312C144.018 13.9664 158.386 25.7583 168.495 40.8876C178.604 56.0169 184 73.8041 184 92C183.972 116.391 174.271 139.776 157.023 157.023C139.776 174.271 116.391 183.972 92 184V184Z",
    fill: "url(#paint0_linear_4750_4285)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9766 157.023C44.2229 174.27 67.6139 183.958 92.0038 183.958C116.394 183.958 139.785 174.27 157.031 157.023C174.277 139.777 183.966 116.386 183.966 91.996C183.966 67.6061 174.277 44.2151 157.031 26.9688L26.9766 157.023Z",
    fill: "url(#paint1_linear_4750_4285)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1869 133.819C50.1607 119.841 53.6449 106.08 60.3197 93.7987C66.9946 81.5172 76.6465 71.1084 88.3901 63.527C100.134 55.9456 113.593 51.4343 127.533 50.4071C141.474 49.3798 155.449 51.8694 168.177 57.6475C162.623 45.307 154.157 34.4994 143.504 26.1533C132.852 17.8072 120.333 12.1723 107.022 9.73273C93.7109 7.29316 80.0068 8.12191 67.087 12.1478C54.1671 16.1736 42.418 23.2762 32.849 32.8451C23.2801 42.414 16.1775 54.1632 12.1517 67.0831C8.12582 80.0029 7.29707 93.707 9.73663 107.018C12.1762 120.329 17.8111 132.848 26.1572 143.5C34.5033 154.153 45.3109 162.619 57.6514 168.173C52.7396 157.386 50.1944 145.672 50.1869 133.819V133.819Z",
    fill: "url(#paint2_linear_4750_4285)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6364 75.2727C68.7198 75.2727 75.2727 68.7198 75.2727 60.6364C75.2727 52.5529 68.7198 46 60.6364 46C52.5529 46 46 52.5529 46 60.6364C46 68.7198 52.5529 75.2727 60.6364 75.2727Z",
    fill: "url(#paint3_linear_4750_4285)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M123.363 75.2727C131.446 75.2727 137.999 68.7198 137.999 60.6364C137.999 52.5529 131.446 46 123.363 46C115.279 46 108.727 52.5529 108.727 60.6364C108.727 68.7198 115.279 75.2727 123.363 75.2727Z",
    fill: "url(#paint4_linear_4750_4285)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6342 71.0927C66.4081 71.0927 71.0888 66.412 71.0888 60.6381C71.0888 54.8643 66.4081 50.1836 60.6342 50.1836C54.8603 50.1836 50.1797 54.8643 50.1797 60.6381C50.1797 66.412 54.8603 71.0927 60.6342 71.0927Z",
    fill: "url(#paint5_linear_4750_4285)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M123.361 71.0927C129.135 71.0927 133.815 66.412 133.815 60.6381C133.815 54.8643 129.135 50.1836 123.361 50.1836C117.587 50.1836 112.906 54.8643 112.906 60.6381C112.906 66.412 117.587 71.0927 123.361 71.0927Z",
    fill: "url(#paint6_linear_4750_4285)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9963 108.727C125.07 108.727 139.891 127.963 140.505 128.799C141.816 130.572 142.374 132.79 142.058 134.971C141.742 137.153 140.578 139.121 138.818 140.449C137.058 141.776 134.846 142.356 132.661 142.061C130.477 141.766 128.497 140.62 127.153 138.873C126.743 138.342 116.544 125.454 91.9963 125.454C67.608 125.454 57.2622 138.33 56.8356 138.877C55.487 140.613 53.5092 141.749 51.3301 142.038C49.1509 142.326 46.9456 141.746 45.1913 140.421C43.4369 139.097 42.2746 137.135 41.9557 134.96C41.6368 132.785 42.187 130.572 43.4873 128.799C44.102 127.963 58.9223 108.727 91.9963 108.727Z",
    fill: "url(#paint7_linear_4750_4285)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M92 112.91C123.008 112.91 136.599 130.557 137.164 131.31C137.829 132.197 138.115 133.313 137.958 134.411C137.801 135.509 137.215 136.499 136.327 137.165C135.44 137.83 134.325 138.116 133.227 137.959C132.129 137.802 131.138 137.216 130.473 136.328C129.971 135.676 118.567 121.274 92 121.274C65.1276 121.274 53.6402 136.178 53.5273 136.328C52.8618 137.216 51.8712 137.802 50.7732 137.959C49.6753 138.116 48.56 137.83 47.6727 137.165C46.7855 136.499 46.1989 135.509 46.042 134.411C45.8852 133.313 46.1709 132.197 46.8364 131.31C47.4009 130.557 60.9918 112.91 92 112.91Z",
    fill: "url(#paint8_linear_4750_4285)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4750_4285",
    x1: 23.8699,
    y1: 15.2553,
    x2: 164.483,
    y2: 173.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7AE30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4750_4285",
    x1: 92.8234,
    y1: 92.8156,
    x2: 157.244,
    y2: 156.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCA4F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4901F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4750_4285",
    x1: 28.5669,
    y1: 27.551,
    x2: 73.0322,
    y2: 72.723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD980"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCA4F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4750_4285",
    x1: 51.8211,
    y1: 49.8598,
    x2: 69.9242,
    y2: 71.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7AE30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCA4F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4750_4285",
    x1: 114.477,
    y1: 50.2236,
    x2: 132.58,
    y2: 71.438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7AE30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCA4F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4750_4285",
    x1: 54.3364,
    y1: 52.9394,
    x2: 67.2708,
    y2: 68.7509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4C56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27333E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4750_4285",
    x1: 117.013,
    y1: 53.1987,
    x2: 129.947,
    y2: 68.3578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4C56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27333E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4750_4285",
    x1: 91.9963,
    y1: 141.399,
    x2: 91.9963,
    y2: 116.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCA4F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7AE30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4750_4285",
    x1: 92,
    y1: 136.433,
    x2: 92,
    y2: 111.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27333E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F4C56"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReject);
export default __webpack_public_path__ + "static/media/reject.fc567f92ed990ef3944cd75e2000ed19.svg";
export { ForwardRef as ReactComponent };